import { JSX } from "react";
import { MD } from "../http/monatsdatenApi";
import i18n from "../i18n";
import Select from "./ui/Select";

type Props = JSX.IntrinsicElements["select"] & { isInvalid?: boolean };

const CompanyTypeSelect = (props: Props) => {
  return (
    <Select {...props}>
      <option />
      {MD.companyTypes.map((type) => (
        <option key={type} value={type}>
          {i18n.getCompanyType(type)}
        </option>
      ))}
    </Select>
  );
};

export default CompanyTypeSelect;
